import React from 'react';
import Radio from 'rsuite/Radio';
import RadioGroup from 'rsuite/RadioGroup';
import SelectPicker from 'rsuite/SelectPicker';
import OptionTitle from 'components/OptionElements/OptionTitle';
import OptionDescription from 'components/OptionElements/OptionDescription';
import OptionLabel from 'components/OptionElements/OptionLabel';
import OptionPrice from 'components/OptionElements/OptionPrice';
import OptionFootnote from 'components/OptionElements/OptionFootnote';
import OptionDropdown from 'components/OptionElements/OptionDropdown';
import { useRadioGroup } from '../hooks';
import * as Utils from 'utils';

export default function OptionTypeRadio(props) {
  const {options} = props;
  const [optionId, onChangeOptionId, onChangeSelectValue] = useRadioGroup(props);

  return (
    <RadioGroup
      className="app-option-list"
      value={optionId}
      onChange={onChangeOptionId}>
      {options.map((option) => {
        const {
          id,
          label = '',
          labelTooltip = '',
          title = '',
          description = '',
          footnote = '',
          dropdownTitle = '',
          dropdownContent = '',
          priceTitle = '',
          customClass = '',
          selectValue = null,
          selectValueList = null,
          isDisabled = false
        } = option;

        return (
          <div className={`app-option-item ${customClass}`} key={id}>
            <OptionTitle title={title} />
            <OptionDescription description={description} />
            <Radio
              className="app-option-radio"
              value={id}
              disabled={isDisabled}>
              <OptionLabel
                label={label}
                labelTooltip={labelTooltip}
              />
              <OptionPrice
                priceTitle={priceTitle}
                priceValueText={Utils.replacer(option, 'priceValueText')}
              />
            </Radio>
            {selectValueList && selectValueList.length > 0 && (
              <SelectPicker
                defaultValue={selectValue}
                data={selectValueList}
                cleanable={false}
                searchable={false}
                onChange={(value) => onChangeSelectValue(value, option)}
              />
            )}
            <OptionDropdown
              dropdownTitle={dropdownTitle}
              dropdownContent={dropdownContent}
            />
            <OptionFootnote footnote={footnote} />
          </div>
        )
      })}
    </RadioGroup>
  )
}
